// extracted by mini-css-extract-plugin
export default {"itemContainerBorder":"RndItem5min_itemContainerBorder__mi0DO","itemContainerPadding":"RndItem5min_itemContainerPadding__zz0Tw","innerBox":"RndItem5min_innerBox__CR781"};